import script from "./TimeTypeTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeTypeTab.vue?vue&type=script&setup=true&lang=js"

import "./TimeTypeTab.vue?vue&type=style&index=0&id=4e45c217&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e45c217"]])

export default __exports__